export const buttonStyles = (theme) => {
  const neonColor = "#00f5ff"; 
  const isDark = theme.palette.mode === "dark"; 
  const bgColor = isDark ? "#0d0d0d" : "#f1f1f1"; 
  const textColor = isDark ? "#fff" : "#333"; 

  return {
    position: "relative",
    padding: "12px 20px",
    fontSize: "16px",
    textTransform: "uppercase",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "0.3s",
    color: textColor,
    background: bgColor,
    border: "2px solid transparent",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: `0 0 5px ${neonColor}`,
    margin: "8px", 

    "&:hover": {
      background: neonColor,
      color: "#000",
      boxShadow: `0 0 20px ${neonColor}, 0 0 40px ${neonColor}`,
    },

    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "8px",
      border: `2px solid ${neonColor}`,
      opacity: 0,
      transition: "opacity 0.3s",
    },

    "&:hover::after": {
      opacity: 1,
      animation: "neon-glow 1.5s linear infinite",
    },

    "@keyframes neon-glow": {
      "0%": { transform: "translateX(-100%)" },
      "50%": { transform: "translateX(100%)" },
      "100%": { transform: "translateX(-100%)" },
    },

    // Медиазапросы для мобильных устройств
    "@media (max-width: 600px)": {
      padding: "8px 14px",  // Уменьшаем отступы на мобильных устройствах
      fontSize: "14px",  // Уменьшаем размер шрифта
      margin: "6px",  // Уменьшаем отступы между кнопками
    },
  };
};

export const buttonStylesLight = (theme) => {
  const neonColor = "#00f5ff"; 
  const isDark = theme.palette.mode === "dark"; 
  const bgColor = isDark ? "#111" : "#fff"; 
  const textColor = isDark ? "#fff" : "#333"; 

  return {
    fontSize: "16px",
    textTransform: "uppercase",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "0.3s",
    color: textColor,
    background: bgColor,
    border: "2px solid transparent",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: `0 0 5px ${neonColor}`,
    margin: "8px",  // Отступы между кнопками

    "&:hover": {
      background: neonColor,
      color: "#000",
      boxShadow: `0 0 20px ${neonColor}, 0 0 40px ${neonColor}`,
    },

    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "8px",
      border: `2px solid ${neonColor}`,
      opacity: 0,
      transition: "opacity 0.3s",
    },

    "&:hover::after": {
      opacity: 1,
      animation: "neon-glow 1.5s linear infinite",
    },

    "@keyframes neon-glow": {
      "0%": { transform: "translateX(-100%)" },
      "50%": { transform: "translateX(100%)" },
      "100%": { transform: "translateX(-100%)" },
    },

 
    "@media (max-width: 600px)": {
      padding: "8px 14px",  
      fontSize: "14px", 
      margin: "6px",  
    },
  };
};
